import BaseApi from 'api/core/baseApi';
import fetchAllPages from 'api/core/fetchAllPages';
import { ENDPOINTS } from 'api/config/endpoints';

class GrnApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.GRN);
  }

  getGRNLines(grnId, params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}${grnId}/lines/?${queryString}`
      : `${this.getResourceUrl()}${grnId}/lines/`;

    return this.httpClient.get(url);
  }

  addGRNLines(grnId, data, grnType = 'po') {
    const endpoint = grnType === 'po' ? 'po/' : 'gate-pass/';
    return this.httpClient.post(
      `${this.getResourceUrl()}${grnId}/lines/multi-add/${endpoint}`,
      data,
    );
  }

  deleteGRNLines(grnId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${grnId}/lines/multi-remove/`,
      data,
    );
  }

  updateGRNStatus(grnId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${grnId}/status/`,
      data,
    );
  }

  getGRNPutaway(warehouseId, params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}put-away/?${queryString}`
      : `${this.getResourceUrl()}put-away/`;

    return this.httpClient.get(url);
  }

  updateGRNLinesShelf(grnId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${grnId}/lines/categories/`,
      data,
    );
  }

  getPrefilledLines(grnId, params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}${grnId}/prefilled-lines/?${queryString}`
      : `${this.getResourceUrl()}${grnId}/prefilled-lines/`;

    return this.httpClient.get(url);
  }

  getAllPrefilledLines(grnId) {
    return fetchAllPages(params => this.getPrefilledLines(grnId, params));
  }

  getGrnLineExport(grnId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${grnId}/lines/export/`,
    );
  }
}

export default new GrnApi();
